export default __webpack_public_path__ + "static/media/404NotFound.ccda957f.png";